"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Archive Admin API
 * Archive Admin API for managing channels retrieving them from the database. This API allows you to interact with the archived_channels database.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArchivedChannelToJSON =
  exports.ArchivedChannelFromJSONTyped =
  exports.ArchivedChannelFromJSON =
    void 0;
var runtime_1 = require("../runtime");
function ArchivedChannelFromJSON(json) {
  return ArchivedChannelFromJSONTyped(json, false);
}
exports.ArchivedChannelFromJSON = ArchivedChannelFromJSON;
function ArchivedChannelFromJSONTyped(json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    channel: !runtime_1.exists(json, "channel") ? undefined : json["channel"],
    timeOfArchiving: new Date(json["time_of_archiving"]),
  };
}
exports.ArchivedChannelFromJSONTyped = ArchivedChannelFromJSONTyped;
function ArchivedChannelToJSON(value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    channel: value.channel,
    time_of_archiving: value.timeOfArchiving.toISOString(),
  };
}
exports.ArchivedChannelToJSON = ArchivedChannelToJSON;
